import { Modal } from 'antd'
import { getExcludeFromGrossProfitDuplicateTitleCopy } from './excludeFromGrossProfit'

/**
 * When other shopping-list rows share this title, confirm which supplier
 * the exclude tick will affect. Unique titles save immediately.
 * @returns {Promise<boolean>} true to save, false if the user cancelled
 */
export function promptExcludeFromGrossProfitDuplicateTitle({
  product,
  products,
  excluding = true,
  confirm = options => Modal.confirm(options),
} = {}) {
  const copy = getExcludeFromGrossProfitDuplicateTitleCopy({
    product,
    products,
    excluding,
  })
  if (!copy) return Promise.resolve(true)

  return new Promise(resolve => {
    confirm({
      title: copy.title,
      content: copy.body,
      okText: copy.okText,
      cancelText: copy.cancelText,
      centered: true,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    })
  })
}

export default promptExcludeFromGrossProfitDuplicateTitle
